// ─── supabaseClient.js ────────────────────────────────────────────────────────
// Credentials are read from environment variables — never hardcode secrets.
// Add to your .env file (NEVER commit .env to git):
//   REACT_APP_SUPABASE_URL=https://xxxx.supabase.co
//   REACT_APP_SUPABASE_ANON_KEY=eyJhbGc...
//
// REQUIRED DATABASE SCHEMA (run in Supabase SQL editor):
//
// -- Profiles table: one row per auth user
// create table profiles (
//   id          uuid primary key references auth.users on delete cascade,
//   username    text,
//   height      text default '175',
//   weight      text default '75',
//   age         text default '28',
//   gender      text default 'M',
//   goal        text default '',
//   weight_goal text default 'Lose Weight',
//   persona     text default 'Balanced',
//   wfh_mode    boolean default false,
//   targets     jsonb default '{}',
//   day_history jsonb default '[]',
//   updated_at  timestamptz default now()
// );
// alter table profiles enable row level security;
// create policy "Users manage own profile"
//   on profiles for all using (auth.uid() = id);
//
// -- Logs table: food entries per user
// create table logs (
//   id          uuid primary key default gen_random_uuid(),
//   user_id     uuid references auth.users on delete cascade,
//   name        text,
//   calories    numeric default 0,
//   protein     numeric default 0,
//   carbs       numeric default 0,
//   fat         numeric default 0,
//   meal_type   text,
//   source      text,
//   log_date    date default current_date,
//   logged_at   timestamptz default now()
// );
// alter table logs enable row level security;
// create policy "Users manage own logs"
//   on logs for all using (auth.uid() = user_id);
// create index logs_user_date on logs (user_id, log_date);
// ─────────────────────────────────────────────────────────────────────────────

import { createClient } from "@supabase/supabase-js";

const SUPABASE_URL  = process.env.REACT_APP_SUPABASE_URL;
const SUPABASE_ANON = process.env.REACT_APP_SUPABASE_ANON_KEY;

export const supabase = createClient(SUPABASE_URL, SUPABASE_ANON);
